import { create } from "zustand";

interface ContextMenuState {
  shouldOpenContextMenu: boolean;
  contextMenuIssueIds: string[];
  setShouldOpenContextMenu: (should: boolean) => void;
  setContextMenuIssueIds: (ids: string[]) => void;
  openContextMenuForIssues: (ids: string[]) => void;
}

export const useContextMenuStore = create<ContextMenuState>((set) => ({
  shouldOpenContextMenu: false,
  contextMenuIssueIds: [],
  setShouldOpenContextMenu: (should) => set({ shouldOpenContextMenu: should }),
  setContextMenuIssueIds: (ids) => set({ contextMenuIssueIds: ids }),
  openContextMenuForIssues: (ids) =>
    set({
      shouldOpenContextMenu: true,
      contextMenuIssueIds: ids,
    }),
}));
